// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Recap_response-message__\\+nhen {
  margin-bottom: 30px;
}

.Recap_title__eatlV {
  margin-top: 28px;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
}

.Recap_card__bgt\\+7 {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #4343ff;
  background: #fff;
}

.Recap_card-top__YC3yB {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  border-radius: 12px 12px 0 0;
  background: #4343ff;
  color: #fff;
}
.Recap_card-top__YC3yB .Recap_price-description__lO2Iu {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.Recap_card-top__YC3yB .Recap_price-month__0PeVd {
  position: relative;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
}
.Recap_card-top__YC3yB .Recap_price-month__0PeVd span {
  font-weight: 600;
  font-size: 52px;
  line-height: 84px;
}
.Recap_card-top__YC3yB .Recap_price-year__-EKsk {
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
}

.Recap_card-content__oLlyp {
  padding: 16px 28px 20px;
}

.Recap_summary__HtRRF {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 8px;
  border-radius: 12px;
  color: #00007a;
}
.Recap_summary-title__JEvRn {
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
}
.Recap_summary-description__hPcSk {
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
}

.Recap_switch__wI\\+RF {
  width: 100%;
  margin: 16px 0;
  display: flex;
  align-items: center;
}
.Recap_switch-labels__aAHCT {
  position: relative;
  display: flex;
  align-items: center;
  width: 154px;
  height: 32px;
  border: 1px solid #d8d8ff;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fff;
  padding: 1px;
}
.Recap_switch-label__TFFmj {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  color: #00007a;
  border-radius: 4px;
  height: 100%;
  transition: all 0.2s ease-in-out;
  -webkit-user-select: none;
          user-select: none;
}
.Recap_switch-label__TFFmj.Recap_active__Pgudr {
  background: #4343ff;
  color: #fff;
}

.Recap_address__8SvNY {
  display: flex;
  justify-content: space-between;
}

.Recap_logo__Lp-fu {
  margin-right: 8px;
}

.Recap_form__QJGHv {
  display: flex;
  flex-direction: column;
}

.Recap_inputs__HloUp {
  margin-bottom: 100px;
}

.Recap_payment__1kXmE {
  margin: 45px 0;
}
.Recap_payment-title__RUoxL {
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}
.Recap_payment-methods__ymWCC {
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}
.Recap_payment-method__FHm0G {
  padding: 20px 12px;
  border-radius: 8px;
  border: 1px solid #d8d8ff;
  text-align: center;
  background: #fff;
  cursor: pointer;
}
.Recap_payment-method__FHm0G.Recap_selected__bMkfX {
  background: #4343ff;
}
.Recap_payment-method__FHm0G.Recap_selected__bMkfX p {
  color: #fff;
}
.Recap_payment-method__FHm0G p {
  font-size: 16px;
  line-height: 28px;
}

.Recap_checkbox-label__Z1iNq {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.Recap_link__fgkZ1 a,
.Recap_link__fgkZ1 a:visited {
  text-decoration: underline;
  color: #00007a;
}

.Recap_button__Qsuww {
  align-self: center;
  width: 200px;
  padding: 0 24px;
}

.Recap_collapsible-card__6\\+Xjf {
  margin-top: 12px;
  padding: 20px;
  background: #fff;
  width: 100%;
}

.Recap_list__P\\+LvG {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.Recap_list-title__yQibW {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.Recap_item__DcXai {
  display: flex;
  align-items: baseline;
}
.Recap_item__DcXai:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

@media screen and (max-width: 600px) {
  .Recap_card-content__oLlyp {
    padding: 16px;
  }
  .Recap_payment__1kXmE {
    margin: 28px 0 20px;
  }
  .Recap_payment-method__FHm0G {
    padding-left: 20px;
    padding-right: 20px;
  }
  .Recap_inputs__HloUp {
    margin-bottom: 32px;
  }
  .Recap_button__Qsuww {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/Recap/Recap.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAIF;;AADA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,mBC5BS;ED6BT,WAAA;AAIF;AAFE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAIJ;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAGN;AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC/DS;AD+DX;AAEE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AADJ;;AAKA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAFF;AAIE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cCtGO;EDuGP,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;AAHJ;AAKI;EACE,mBCjHK;EDkHL,WAAA;AAHN;;AAQA;EACE,aAAA;EACA,8BAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,cAAA;AALF;AAOE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC7IO;ADwIX;AAQE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;AANJ;AASE;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AASI;EACE,mBCpKK;AD6JX;AASM;EACE,WAAA;AAPR;AAWI;EACE,eAAA;EACA,iBAAA;AATN;;AAeE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnLO;ADuKX;;AAiBE;;EAEE,0BAAA;EACA,cC3LO;AD6KX;;AAkBA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAfF;AAiBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCxNO;ADyMX;;AAmBA;EACE,aAAA;EACA,qBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAhBJ;;AAoBA;EACE;IACE,aAAA;EAjBF;EAoBA;IACE,mBAAA;EAlBF;EAoBE;IACE,kBAAA;IACA,mBAAA;EAlBJ;EAsBA;IACE,mBAAA;EApBF;EAuBA;IACE,WAAA;EArBF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.response-message {\n  margin-bottom: 30px;\n}\n\n.title {\n  margin-top: 28px;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 48px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid colors.$primary4;\n  background: #fff;\n}\n\n.card-top {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0;\n  border-radius: 12px 12px 0 0;\n  background: colors.$primary4;\n  color: #fff;\n\n  .price-description {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  .price-month {\n    position: relative;\n    font-weight: 400;\n    font-size: 28px;\n    line-height: 48px;\n\n    span {\n      font-weight: 600;\n      font-size: 52px;\n      line-height: 84px;\n    }\n  }\n\n  .price-year {\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n.card-content {\n  padding: 16px 28px 20px;\n}\n\n.summary {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 8px;\n  border-radius: 12px;\n  color: colors.$primary8;\n\n  &-title {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 28px;\n  }\n\n  &-description {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 28px;\n  }\n}\n\n.switch {\n  width: 100%;\n  margin: 16px 0;\n  display: flex;\n  align-items: center;\n\n  &-labels {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 154px;\n    height: 32px;\n    border: 1px solid colors.$primary2;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: #fff;\n    padding: 1px;\n  }\n\n  &-label {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    color: colors.$primary8;\n    border-radius: 4px;\n    height: 100%;\n    transition: all 0.2s ease-in-out;\n    user-select: none;\n\n    &.active {\n      background: colors.$primary4;\n      color: #fff;\n    }\n  }\n}\n\n.address {\n  display: flex;\n  justify-content: space-between;\n}\n\n.logo {\n  margin-right: 8px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputs {\n  margin-bottom: 100px;\n}\n\n.payment {\n  margin: 45px 0;\n\n  &-title {\n    margin-bottom: 16px;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n\n  &-methods {\n    display: grid;\n    grid-auto-flow: column;\n    gap: 12px;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  &-method {\n    padding: 20px 12px;\n    border-radius: 8px;\n    border: 1px solid colors.$primary2;\n    text-align: center;\n    background: #fff;\n    cursor: pointer;\n\n    &.selected {\n      background: colors.$primary4;\n\n      p {\n        color: #fff;\n      }\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 28px;\n    }\n  }\n}\n\n.checkbox {\n  &-label {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n.link {\n  a,\n  a:visited {\n    text-decoration: underline;\n    color: colors.$primary8;\n  }\n}\n\n.button {\n  align-self: center;\n  width: 200px;\n  padding: 0 24px;\n}\n\n.collapsible-card {\n  margin-top: 12px;\n  padding: 20px;\n  background: #fff;\n  width: 100%;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .card-content {\n    padding: 16px;\n  }\n\n  .payment {\n    margin: 28px 0 20px;\n\n    &-method {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }\n\n  .inputs {\n    margin-bottom: 32px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"response-message": `Recap_response-message__+nhen`,
	"title": `Recap_title__eatlV`,
	"card": `Recap_card__bgt+7`,
	"card-top": `Recap_card-top__YC3yB`,
	"price-description": `Recap_price-description__lO2Iu`,
	"price-month": `Recap_price-month__0PeVd`,
	"price-year": `Recap_price-year__-EKsk`,
	"card-content": `Recap_card-content__oLlyp`,
	"summary": `Recap_summary__HtRRF`,
	"summary-title": `Recap_summary-title__JEvRn`,
	"summary-description": `Recap_summary-description__hPcSk`,
	"switch": `Recap_switch__wI+RF`,
	"switch-labels": `Recap_switch-labels__aAHCT`,
	"switch-label": `Recap_switch-label__TFFmj`,
	"active": `Recap_active__Pgudr`,
	"address": `Recap_address__8SvNY`,
	"logo": `Recap_logo__Lp-fu`,
	"form": `Recap_form__QJGHv`,
	"inputs": `Recap_inputs__HloUp`,
	"payment": `Recap_payment__1kXmE`,
	"payment-title": `Recap_payment-title__RUoxL`,
	"payment-methods": `Recap_payment-methods__ymWCC`,
	"payment-method": `Recap_payment-method__FHm0G`,
	"selected": `Recap_selected__bMkfX`,
	"checkbox-label": `Recap_checkbox-label__Z1iNq`,
	"link": `Recap_link__fgkZ1`,
	"button": `Recap_button__Qsuww`,
	"collapsible-card": `Recap_collapsible-card__6+Xjf`,
	"list": `Recap_list__P+LvG`,
	"list-title": `Recap_list-title__yQibW`,
	"item": `Recap_item__DcXai`
};
export default ___CSS_LOADER_EXPORT___;
